import { render } from "./PButton.vue?vue&type=template&id=fbed76b2&scoped=true"
import script from "./PButton.vue?vue&type=script&lang=js"
export * from "./PButton.vue?vue&type=script&lang=js"

import "./PButton.vue?vue&type=style&index=0&id=fbed76b2&lang=less"
import "./PButton.vue?vue&type=style&index=1&id=fbed76b2&lang=less&scoped=true"

import exportComponent from "/builds/sqMDsSTzB/0/dsp/plazkart-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbed76b2"]])

export default __exports__